<div class="flex flex-top flex-justify-center w-12 w-8-s w-8-m">
    @for (step of steps; track $index) {
    @if($index > 0) {
    <div class="progress-bar"
         [ngClass]="isEnabled(step) ? 'bg-col-1' :'bg-col-4'">
    </div>
    }
    <href [link]="step?.link"
          class="center "
          [ngClass]="isEnabled(step) ? 'col-1 cursor-pointer' :'col-4'"
          (click)="pick(step)">
        <div class="progress-dot"
             [ngClass]="isEnabled(step) ? 'bg-col-1' :'bg-col-4'"></div>
        <div class="progress-label">
            <div class="progress-label-content pt"
                 [sizeClass]="'S: c1, !S:p2'">{{step.stepTitle}}</div>
        </div>
    </href>
    }
</div>
